<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    persistent
  >
    <v-card
      class="pa-3"
      elevation-1
      hover
    >
      <v-card-title>
        <h2 class="primary--text font-weight-regular mx-auto">
          ¿ Confirma su asistencia al Turno del día <b>{{ this.$route.query.fecha | parseDate }}</b> ?
        </h2>
      </v-card-title>
      <div class="text-xs-right mt-6">
        <v-btn
          class="error"
          :disabled="loading"
          :loading="loading"
          @click="confirmAppointment"
        >
          Si
        </v-btn>
        <v-btn
          class="primary"
          :disabled="loading"
          :loading="loading"
          @click="cancelar"
        >
          No
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { confirmarTurno } from '../api/appointmentsEndpoints'
import { verificarPaciente } from '../api/userEndpoints'
import moment from 'moment'

export default {
  name: 'AppointmentConfirmView',
  filters: {
    parseDate (val) {
      moment.locale('es')
      return moment(val).format('dddd DD-MM-YYYY').toUpperCase()
    }
  },
  data () {
    return {
      loading: false,
      dialog: true,
      menu: false
    }
  },
  async mounted () {
    this.loading = true
    const verifiedPatient = await verificarPaciente((this.$route.query.pid) ? this.$route.query.pid : this.$route.query.p)
    if (verifiedPatient.respuesta === 'ERROR') {
      this.$createAlert({
        message: verifiedPatient.mensaje,
        type: 'error',
        duration: 5000
      })
      this.$router.replace({ name: 'SelectionView' })
    } else {
      await this.$store.dispatch('setUser', { patient: verifiedPatient.paciente })
      this.loading = false
    }
  },
  methods: {
    async confirmAppointment () {
      const prepareObject = {
        pacienteId: (this.$route.query.pid) ? this.$route.query.pid : this.$route.query.p,
        fecha: this.$route.query.fecha
      }
      this.loading = true
      const confirmAppointment = await confirmarTurno(prepareObject)
      this.cancelar()
      if (confirmAppointment.respuesta === 'ERROR') {
        this.$createAlert({
          message: confirmAppointment.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        this.$createAlert({
          message: 'Turno Confirmado',
          type: 'success',
          duration: 3000
        })
      }
      this.$router.replace({ name: 'AppointmentsView' })
    },
    cancelar () {
      this.$router.replace({ name: 'AppointmentsView' })
    }
  }
}
</script>

<style scoped lang="sass">
  .progress-circle
    margin: 40vh auto
</style>
